import { ToggleButton, ToggleButtonGroup, Box, Typography } from "@mui/material";

const total = 12;

const BlockLength = ({ type, selected, setSelected }) => {
    const handleChange = (event, value) => {
        if (value !== null) setSelected(value);
    };

    return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
                { `Vista ${type}` }
            </Typography>
            <ToggleButtonGroup
                exclusive
                value={selected}
                onChange={handleChange}
                sx={{
                    display: "flex",
                    alignItems: "stretch",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "hidden",
                    height: 40,
                    position: "relative"
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "100%",
                        width: `${(selected / total) * 100}%`, // ancho proporcional
                        backgroundColor: "#EDF7ED",
                        transition: "width 0.3s ease",
                        zIndex: 0,
                    }}
                />

                {
                    Array.from({ length: total }, (_, i) => (
                        <ToggleButton
                            key={i + 1}
                            value={i + 1}
                            sx={{
                                flexGrow: 1,
                                zIndex: 1,
                                color: i + 1 <= selected ? "black" : "gray",
                                "&.Mui-selected": {
                                    backgroundColor: "transparent",
                                }
                            }}
                        >
                            {i + 1}
                        </ToggleButton>
                    ))
                }
            </ToggleButtonGroup>

            <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                Bloque ocupará <b>{selected}</b> columnas de 12
            </Typography>
        </Box>
    );
};

export default BlockLength;